var Checkout = {
    init: function () {
        $(document)
            .on('change', '.jsChangePayment', Checkout.changePayment)
            .on('change', '.jsChangeAddress', Checkout.changeAddress)
            .on('change', '.jsShipAdrs input', Checkout.changeShippingAddress)
            .on('change', '.jsFakturaAdrs input', Checkout.changeBillingAddress)
            .on('change', '.js-radio-private', Checkout.hideCorpFields)
            .on('change', '.js-radio-corp', Checkout.resetCorpFields)
            .on('change', '.js-QLPriv', Checkout.hideQLCorpFields)
            .on('change', '.js-QLCorp', Checkout.resetQLCorpFields)
            .on('change', '.jsChangeTaxAddress', Checkout.changeTaxAddress)
            .on('change', '#MiniCart', Checkout.refreshView)
            .on('change', '#QuoteListMiniCart', Checkout.refreshView)
            .on('change', '#MiniCartResponsive', Checkout.refreshView)
            .on('change', '#QuoteListMiniCartResponsive', Checkout.refreshView)
            .on('change', '#CheckoutView .jsChangeCartItem', Checkout.refreshView)
            .on('click', '.jsNewAddress', Checkout.newAddress)
            .on('click', '#AlternativeAddressButton', Checkout.enableShippingAddress)
            .on('click', '.remove-shipping-address', Checkout.removeShippingAddress)
            .on('click', '.btnCheckout', Checkout.showCheckoutForm)
            .on('click', '.js-hide-billing', Checkout.hideBillingForm)
            .on('click', '.js-other-address-line', Checkout.showBillingForm)
            .on('click', '.js-show-additional-information', Checkout.showAdditionalInformation)
            .on('click', '.js-hide-additional-information', Checkout.hideAdditionalInformation);

       


        Checkout.initializeAddressAreas();
        Checkout.changeTaxAddress();

        Checkout.reInitTermsAndPrivateCustomer();
    },
    showCheckoutForm: function () {
        $(".jsCheckoutForm").show();
        document.querySelector('.jsCheckoutForm').scrollIntoView({
            behavior: 'smooth'
        });
    },
    hideBillingForm: function () {
        //console.log("hiding billingz");
        //$('.js-billing-container').hide();
    },
    showBillingForm: function () {
        //console.log("showing billingz");
        //console.log("showing billingz");
        //$('.js-billing-container').show();
    },
    showAdditionalInformation: function (e) {
        e.preventDefault();
        $('.js-additional-information').removeClass("hidden");
        $('.js-show-additional-information').addClass("hidden");
    },
    hideAdditionalInformation: function (e) {
        e.preventDefault();
        $('.js-additional-information').addClass("hidden");
        $('.js-show-additional-information').removeClass("hidden");
    },

    initializeAddressAreas: function () {
        if ($("#UseBillingAddressForShipment").val() == "False") {
            //Checkout.doEnableShippingAddress();
        }
        else {
            //Checkout.doRemoveShippingAddress();
        }
    },
    wto: null,
    refreshView: function () {
        if ($(".confirmation")[0]) {
            return;
        }

        var view = $("#CheckoutView");

        if (view.length == 0) {
            return;
        }
        clearTimeout(Checkout.wto);
        Checkout.wto = setTimeout(function () {
            $.ajax({
                cache: false,
                type: "GET",
                url: view.data('url'),
                success: function (result) {
                    view.replaceWith($(result));
                    Checkout.initializeAddressAreas();
                }
            });
        }, 400);
    },
    newAddress: function (e) {
        e.preventDefault();
        AddressBook.showNewAddressDialog($(this));
    },
    changeAddress: function () {
        var form = $('.jsCheckoutForm');
        var id = $(this).attr("id");
        var isBilling = id.indexOf("Billing") > -1;
        if (isBilling) {
            $("#ShippingAddressIndex").val(-1);
        } else {
            // $("#ShippingAddressIndex").val($(".jsChangeAddress").index($(this)) - 1);
            $("#ShippingAddressIndex").val(0);
        }

        $.ajax({
            type: "POST",
            cache: false,
            url: $(this).closest('.jsCheckoutAddress').data('url'),
            data: form.serialize(),
            success: function (result) {
                if (isBilling) {
                    $("#billingAddressContainer").html($(result));
                } else {
                    $("#AddressContainer").html($(result));
                }
                Checkout.initializeAddressAreas();
                Checkout.updateOrderSummary();
            }
        });
    },
    hideCorpFields: function () {
        $(".js-hide-private").hide();
        $(".js-hide-private-form").hide();
        var forms = $(".js-hide-private-form");

        //populate forms for backend validation to pass
        forms[0].value = "Private customer";
        forms[1].value = "^^RJ$$";
        forms[2].value = "Private customer";
        forms[3].value = "Private customer";
    },
    hideQLCorpFields: function () {
        $(".js-hide-QL-private").hide();
        $(".QLComp").hide();
        var formQL = document.forms["formQL"];
        formQL["QuoteFormModel.CompanyName"].value = "Private customer";
        if ($(".validation-summary-errors").length > 0)
            $(".js-formQL").validate().form();
    },
    reInitTermsAndPrivateCustomer: function () {

        var privateBox = $('#PrivCustomer').is(":checked");
        var termsBox = $('#termsCheckbox').is(":checked");
        if (privateBox) {
            Checkout.hideCorpFields();
        }
        if (termsBox) {
            document.getElementById('paymentButton').disabled = !$('#termsCheckbox').is(":checked");
        }
    },
    resetCorpFields: function () {
        $(".js-hide-private").show();
        $(".js-hide-private-form").show();
        var forms = $(".js-hide-private-form");
        forms[0].value = "";
        forms[1].value = "";
        forms[2].value = "";
        forms[3].value = "";
    },
    resetQLCorpFields: function () {
        $(".js-hide-QL-private").show();
        $(".QLComp").show();
        var formQL = document.forms["formQL"];
        formQL["QuoteFormModel.CompanyName"].value = "";
        if ($(".validation-summary-errors").length > 0)
            $(".js-formQL").validate().form();
    },
    changeShippingAddress: function () {
        var $this = $(this);
        $("#Shipments_0__Address_Receiver").val($this.data("receiver"));
        $("#Shipments_0__Address_Line1").val($this.data("line1"));
        $("#Shipments_0__Address_PostalCode").val($this.data("postalcode"));
        $("#Shipments_0__Address_City").val($this.data("city"));
        if ($this.val() == "on") {
            $("#Shipments_0__Address_Name").val("Shipping");
        }
        else {
            $("#Shipments_0__Address_Name").val($this.attr("id"));
        }
        $(".js-delivery-address-logged-in").removeClass("delivery-address-logged-in");

    },
    changeBillingAddress: function () {
        var $this = $(this);
        Checkout.createHiddenInputField("BillingAddress_Receiver", "BillingAddress.Receiver");
        $("#BillingAddress_Receiver").val($this.data("receiver"));
        Checkout.createHiddenInputField("BillingAddress_Line1", "BillingAddress.Line1");
        $("#BillingAddress_Line1").val($this.data("line1"));
        Checkout.createHiddenInputField("BillingAddress_PostalCode", "BillingAddress.PostalCode");
        $("#BillingAddress_PostalCode").val($this.data("postalcode"));
        Checkout.createHiddenInputField("BillingAddress_City", "BillingAddress.City");
        $("#BillingAddress_City").val($this.data("city"));
    },
    createHiddenInputField: function (fieldId, fieldName) {
        if ($("#" + fieldId).length == 0) {
            $("<input>").attr({
                name: fieldName,
                id: fieldId,
                type: "hidden"
            }).appendTo(".billings");
        }
    },
    changeTaxAddress: function (sender) {
        if (sender == undefined) {
            return;
        }
        if (sender.originalEvent instanceof Event) {
            sender = $(this);
        }
        var id = $(sender).attr("id");
        if ((id.indexOf("Billing") > -1) && $("#UseBillingAddressForShipment").val() == "False") {
            return;
        }
        var form = $('.jsCheckoutForm');
        if (form.length == 0) {
            return;
        }
        $.ajax({
            type: "POST",
            cache: false,
            url: $(sender).closest('.jsCheckoutAddress').data('url'),
            data: form.serialize(),
            success: function (result) {
                Checkout.updateOrderSummary();
            }
        });
    },
    changePayment: function () {
        $.ajax({
            type: "POST",
            url: $(this).data('url'),
            success: function (result) {
                console.log("Testing12");
                $('.jsPaymentMethod').replaceWith($(result).find('.jsPaymentMethod'));
                Checkout.updateOrderSummary();
                Misc.updateValidation('jsCheckoutForm');
               $('.js-invoice-spinner').remove();
            }
        });
    },
    updateOrderSummary: function () {
        $.ajax({
            cache: false,
            type: "GET",
            url: $('.jsOrderSummary').data('url'),
            success: function (result) {
                $('.jsOrderSummary').replaceWith($(result).filter('.jsOrderSummary'));
            }
        });
    },
    doEnableShippingAddress: function () {
        $("#AlternativeAddressButton").hide();
        $(".shipping-address:hidden").slideToggle(300);
        $(".shipping-address").css("display", "block");
        $("#UseBillingAddressForShipment").val("False");
    },
    enableShippingAddress: function (event) {
        event.preventDefault();

        Checkout.doEnableShippingAddress();

        var form = $('.jsCheckoutForm');
        $("#ShippingAddressIndex").val(0);

        $.ajax({
            type: "POST",
            cache: false,
            url: $('.jsCheckoutAddress').data('url'),
            data: form.serialize(),
            success: function (result) {
                $("#AddressContainer").html($(result));
                Checkout.initializeAddressAreas();
                Checkout.updateOrderSummary();
            }
        });
    },
    doRemoveShippingAddress: function () {
        $("#AlternativeAddressButton").show();
        $(".shipping-address:visible").slideToggle(300);
        $(".shipping-address").css("display", "none");
        $("#UseBillingAddressForShipment").val("True");
    },
    removeShippingAddress: function (event) {

        event.preventDefault();

        Checkout.doRemoveShippingAddress();

        var form = $('.jsCheckoutForm');
        $("#ShippingAddressIndex").val(-1);

        $.ajax({
            type: "POST",
            cache: false,
            url: $('.jsCheckoutAddress').data('url'),
            data: form.serialize(),
            success: function (result) {
                Checkout.initializeAddressAreas();
                Checkout.updateOrderSummary();
            }
        });
    }
};
$(window).bind('pageshow', function () {
    Checkout.reInitTermsAndPrivateCustomer();
});